import React, { Component } from 'react';
export default class Header extends Component {
  render() {
    // let resumeData = this.props.resumeData;
    return (
      <React.Fragment>
      
      <header id="home" style={{ height: 250, backgroundImage: 'url(images/header-background2a_auto_x2.jpg)', backgroundRepeat: 'no-repeat', backgroundPosition: 'top center', backgroundSize: 'cover',  }}>
         <nav id="nav-wrap">
            <a className="mobile-btn" href="#nav-wrap" title="Show navigation">Show navigation</a>
          <a className="mobile-btn" href="#" title="Hide navigation">Hide navigation</a>
            <ul id="nav" className="nav">
               <li className="current"><a className="smoothscroll" href="#home">Home</a></li>
               <li><a className="smoothscroll" href="#about">About</a></li>
             <li><a className="smoothscroll" href="#services">Services</a></li>
               <li><a className="smoothscroll" href="#plans">Plans/Pricing</a></li>
               <li><a className="smoothscroll" href="#partners">Partners</a></li>
               <li><a className="smoothscroll" href="#contact">Contact</a></li>
               <li><a href="https://blog.pythonicit.com">Blog</a></li>
            </ul>
         </nav>

         <div className="row banner">
            <div className="banner-text">
            <h1 className="responsive-headline">
              <img
                src="images/pythonicitlogo.png"
                alt="PythonicIT Logo"
                className="company-logo"
                style={{ height: 120 }}
              />
              <span style={{ textShadow: '4px 4px 8px black', color: 'white' }}>PythonicIT</span>
            </h1>
               <h3 style={{ color: 'white', fontFamily: 'sans-serif', fontWeight: 'bold', fontSize: 'larger', textShadow: '2px 2px 0px black' }}>Empowering Your Business with Automation, Security, and IT Support
               </h3>
               <hr/>
               
            </div>
         </div>

      

      </header>
      </React.Fragment>
    );
  }
}